<template>
  <Modal ref="modal">
    <div class="row">
      <div class="form-group col-6">
        <label class="col-4">Name:</label>
        <input
          class="form-control col"
          type="text"
          v-model="wish.name"
          placeholder="Name of wish"
        />
      </div>

      <div class="form-group col-4">
        <label class="col-4">Value:</label>
        <input
          class="form-control col"
          type="number"
          v-model="wish.value"
          placeholder="0.00"
          currency
        />
      </div>
    </div>

    <div class="form-group">
      <label class="col-4">Description:</label>
      <textarea
        class="form-control col"
        v-model="wish.description"
      ></textarea>
    </div>

    <div>
      <button class="btn btn-dark" v-on:click="$refs.modal.ok()">OK</button>
      <button class="btn btn-dark" v-on:click="$refs.modal.cancel()">
        Anuluj
      </button>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      wish: {}
    };
  },
  methods: {
    show(wish) {
      this.wish = this.$tools.copyOf(wish);

      return this.$refs.modal.open().then(() => {
        return this.wish;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>